import { FC } from 'react';
import styled, { css } from 'styled-components';

import Text from '@/components/Text';

const Badge = styled(Text)<{ $cardView: boolean }>`
  display: inline-flex;
  height: 27px;
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  svg {
    margin-right: 8px;
    color: ${({ theme }) => theme.colors.gray};
  }

  ${({ $cardView }) =>
    $cardView &&
    css`
      border: 0;
      padding: 0;
    `}
`;

const Wrap = styled.div<{ $cardView: boolean }>`
  ${({ $cardView }) =>
    $cardView &&
    css`
      border: 0;
      padding: 0;
    `}
`;

interface Props {
  isReel: boolean;
  cardView?: boolean;
  videoUrl?: string;
}

const ReleaseTypeBadge: FC<Props> = ({
  isReel,
  videoUrl,
  cardView = false,
}) => {
  const renderBadge = () => {
    if (isReel) {
      return (
        <Badge
          as={videoUrl ? 'a' : 'div'}
          $type="smallHeadline"
          $cardView={cardView}
          {...(!!videoUrl && { href: videoUrl, target: '_blank' })}
        >
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_9662_178806)">
              <path
                d="M10.5 8.5L6.5 6V11L10.5 8.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect
                x="0.75"
                y="1.25"
                width="14.5"
                height="14.5"
                rx="3.25"
                stroke="currentColor"
                strokeWidth="1.5"
              />
            </g>
            <defs>
              <clipPath id="clip0_9662_178806">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
          Reel
        </Badge>
      );
    }
    return (
      <Badge
        as={videoUrl ? 'a' : 'div'}
        $type="smallHeadline"
        $cardView={cardView}
        {...(!!videoUrl && { href: videoUrl, target: '_blank' })}
      >
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 4.25H9.5C10.0304 4.25 10.5391 4.46071 10.9142 4.83579C11.2893 5.21086 11.5 5.71957 11.5 6.25V12.25C11.5 12.3826 11.4473 12.5098 11.3536 12.6036C11.2598 12.6973 11.1326 12.75 11 12.75H3C2.46957 12.75 1.96086 12.5393 1.58579 12.1642C1.21071 11.7891 1 11.2804 1 10.75V4.75C1 4.61739 1.05268 4.49021 1.14645 4.39645C1.24021 4.30268 1.36739 4.25 1.5 4.25V4.25Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.5 7.5L15 5.5V11.5L11.5 9.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Video
      </Badge>
    );
  };

  return <Wrap $cardView={cardView}>{renderBadge()}</Wrap>;
};

export default ReleaseTypeBadge;
